import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useAlgoliaProductIndex} from 'components/algolia/WithAlgolia';
import {favoriteListsSelectors} from 'features/favoriteListsSlice';

/**
 * Favorite lists can contain wines synced in from FS Cockpit that no longer
 * exist as real products, so the backend's wineCount overcounts. This
 * resolves every favorited wine against Algolia once and returns a function
 * that counts, per list, only the wines that actually exist as products.
 */
export function useValidFavoriteListWineCount() {
  const productIndex = useAlgoliaProductIndex();
  const productIndexReady = productIndex && productIndex.appId;
  const listDetails = useSelector(favoriteListsSelectors.listDetails);
  const allFavoritedWineIds = useSelector(favoriteListsSelectors.allFavoritedWineIds);

  const [validWineIds, setValidWineIds] = useState(null);
  useEffect(() => {
    if (productIndexReady && allFavoritedWineIds) {
      if (allFavoritedWineIds.length === 0) {
        setValidWineIds(new Set());
      } else {
        productIndex.getObjects(allFavoritedWineIds).then((result) => {
          setValidWineIds(new Set(result.results.filter(product => product && product.objectID).map(product => product.objectID)));
        });
      }
    }
  }, [productIndexReady, allFavoritedWineIds, productIndex]);

  return (list) => {
    if (!validWineIds) return list.wineCount;
    const wines = listDetails[list.id] ?? [];
    return wines.filter(wine => validWineIds.has(String(wine.wineId))).length;
  };
}
